<template>
  

<div>
<!-- Static sidebar for desktop -->
<div
  class="min-h-screen !relative w-64 flex-col hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col z-50">
  <!-- Sidebar component, swap this element with another sidebar if you like -->
  <div class="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
    <div class="flex-1 flex flex-col px-3 pt-3 gap-2">
      <div class="relative inline-block text-left w-full">
        <button
          type="button"
          @click="openSwitcher"
          class=" btn btn-icon btn-neutral w-full justify-between"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true">
          <span class="flex items-center">
            <svg class="h-6 w-6" width="119" height="119" viewBox="0 0 119 119" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40.97 59.9998L76.97 0H118.47V41.5L40.97 59.9998L118.47 79.5V119H76.97L40.97 62V67C43.47 84.3333 51.4666 117.594 49.9698 117.5C41.9697 117.001 26.9698 112.5 14.4698 97.5003C13.97 96.9005 31.4698 72.0003 37.97 62L2.96977 74C-0.530046 69.5003 -1.03027 52.5004 1.97001 47.0004C2.44868 46.1229 26.9697 55 37.97 59L14.4698 22.0004C17.4697 15.4998 31.4697 2.99976 50.4697 1.5002C50.4697 1.5002 43.97 40.4998 40.4697 58.9998L40.97 59.9998Z" fill="#FF3300"/>
</svg>

            
            <span  class="text-base text-gray-900 ml-3 font-medium first-letter:uppercase"
              >{{dropMenuTitle}}</span
            >
          </span>
          <!-- Heroicon name: solid/chevron-down -->
          <svg
            class="-mr-1 ml-2 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </button>
        <!--selection -panel-->
        <!--show dashboard div starts-->
     <prodcut-switcher v-if="appSwitcher" 
     @close-switcher="closeSwitcher"
     @selected-menu="selectMenu"
     :menuTitle="dropMenuTitle"
     :products="productLists"
     ></prodcut-switcher>
        <!--show dashboard div ends-->
        <!--selection -panel-->
      </div>
      <a
        href="#"
        class="flex items-center px-3 py-1 hover:bg-slate-50 rounded-md">
        <div class="flex flex-1 flex-col">
          <p class="text-sm">Freshworks</p>
          <p class="text-[10px] text-[#64648C]">freshworks.chargebee.com</p>
        </div>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.23431 9.83441C4.54673 9.52199 5.05326 9.52199 5.36568 9.83441L7.99999 12.4687L10.6343 9.83441C10.9467 9.52199 11.4533 9.52199 11.7657 9.83441C12.0781 10.1468 12.0781 10.6534 11.7657 10.9658L8.56568 14.1658C8.25326 14.4782 7.74673 14.4782 7.43431 14.1658L4.23431 10.9658C3.9219 10.6534 3.9219 10.1468 4.23431 9.83441Z"
            fill="#64648C" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.23431 6.16559C4.54673 6.47801 5.05326 6.47801 5.36568 6.16559L7.99999 3.53127L10.6343 6.16559C10.9467 6.47801 11.4533 6.47801 11.7657 6.16559C12.0781 5.85317 12.0781 5.34664 11.7657 5.03422L8.56568 1.83422C8.25326 1.5218 7.74673 1.5218 7.43431 1.83422L4.23431 5.03422C3.9219 5.34664 3.9219 5.85317 4.23431 6.16559Z"
            fill="#64648C" />
        </svg>
      </a>
      <!--search-->
      <nav-search></nav-search>
      <!--search end-->
      <!-- menu item start -->
    
     <cb-menu v-if="cbMenu"></cb-menu>
  

     <payments-menu v-else></payments-menu>
      <!-- menu item ends -->
    </div>
    <!-- user profile bottom -->
    
<div class="flex border-t border-gray-200 p-4 flex-col">
  <a href="#" class="px-3 py-2 hover:bg-slate-50 rounded-md">
    <div class="flex items-center">
      <div class="flex justify-center items-center w-6">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_4748_22919"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="4"
            y="4"
            width="16"
            height="16">
            <rect x="4" y="4" width="16" height="16" fill="white" />
          </mask>
          <g mask="url(#mask0_4748_22919)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.9979 13.4361C19.9982 12.2193 19.1965 11.1347 17.9979 10.7304V10.2446C17.9979 7.07196 15.3116 4.5 11.9979 4.5C8.68414 4.5 5.99785 7.07196 5.99785 10.2446V10.7304C4.80032 11.1367 4 12.2213 4 13.4377C4 14.6541 4.80032 15.7387 5.99785 16.145C6.3039 16.2486 6.64342 16.2035 6.90848 16.0241C7.17353 15.8447 7.33114 15.5533 7.33119 15.2425V10.2446C7.33119 7.777 9.42052 5.77659 11.9979 5.77659C14.5752 5.77659 16.6645 7.777 16.6645 10.2446V15.2425C16.6674 15.511 16.7884 15.7659 16.9979 15.9446V16.3084C16.9979 17.2493 16.1372 17.585 15.3312 17.585H14.1459C13.8441 17.0846 13.229 16.8407 12.6461 16.9902C12.0631 17.1398 11.6578 17.6455 11.6578 18.2233C11.6578 18.8011 12.0631 19.3068 12.6461 19.4564C13.229 19.6059 13.8441 19.362 14.1459 18.8616H15.3312C17.0972 18.8616 18.3312 17.8116 18.3312 16.3084V16.0033C19.3501 15.5193 19.9955 14.5252 19.9979 13.4361ZM12.8312 15.192C12.8312 15.6327 12.4581 15.9899 11.9979 15.9899C11.5376 15.9899 11.1645 15.6327 11.1645 15.192C11.1645 14.7514 11.5376 14.3942 11.9979 14.3942C12.4581 14.3942 12.8312 14.7514 12.8312 15.192ZM11.1645 10.4042C11.1645 10.8449 10.7914 11.2021 10.3312 11.2021C9.87121 11.2021 9.49822 10.8452 9.49785 10.4048C9.49869 9.20967 10.4202 8.19824 11.6569 8.03522C12.8935 7.8722 14.0662 8.60755 14.4044 9.75805C14.7425 10.9085 14.1425 12.1215 12.9985 12.5999C12.8971 12.6424 12.8316 12.7384 12.8319 12.8444V13.1987C12.8319 13.6393 12.4588 13.9965 11.9985 13.9965C11.5383 13.9965 11.1652 13.6393 11.1652 13.1987V12.8444C11.1653 12.1044 11.623 11.4347 12.3312 11.1382C12.7123 10.979 12.9125 10.5751 12.8003 10.1917C12.6881 9.80835 12.2979 9.56284 11.8858 9.61637C11.4738 9.6699 11.166 10.0061 11.1645 10.4042Z"
              fill="#64648C" />
          </g>
        </svg>
      </div>
      <div class="ml-3 flex flex-1 items-center justify-between">
        <p class="text-sm text-gray-700 group-hover:text-gray-900">
          Need Help?
        </p>
        <svg
          width="16"
          height="4"
          viewBox="0 0 16 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.55556 2.00016C3.55556 2.92064 2.75962 3.66683 1.77778 3.66683C0.795938 3.66683 0 2.92064 0 2.00016C0 1.07969 0.795938 0.333496 1.77778 0.333496C2.75962 0.333496 3.55556 1.07969 3.55556 2.00016Z"
            fill="#64648C" />
          <path
            d="M8 3.66683C8.98184 3.66683 9.77778 2.92064 9.77778 2.00016C9.77778 1.07969 8.98184 0.333496 8 0.333496C7.01816 0.333496 6.22222 1.07969 6.22222 2.00016C6.22222 2.92064 7.01816 3.66683 8 3.66683Z"
            fill="#64648C" />
          <path
            d="M14.2222 3.66683C15.2041 3.66683 16 2.92064 16 2.00016C16 1.07969 15.2041 0.333496 14.2222 0.333496C13.2404 0.333496 12.4444 1.07969 12.4444 2.00016C12.4444 2.92064 13.2404 3.66683 14.2222 3.66683Z"
            fill="#64648C" />
        </svg>
      </div>
    </div>
  </a>
  <!-- user profile -->
  <a href="#" class="px-3 py-2 hover:bg-slate-50 rounded-md">
    <div class="flex items-center">
      <div class="relative flex justify-center items-center w-6">
        <div
          class=" bottom-4 left-4 bg-red w-3 h-3 bg-orange-500 rounded-full border-2 border-white"></div>
        <img
          class="inline-block h-6 w-6 rounded-full"
          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
          alt="" />
      </div>
      <div class="ml-3 flex flex-1 items-center justify-between">
        <p class="text-sm text-gray-700 group-hover:text-gray-900">
          Antonio Carter
        </p>
        <svg
          width="16"
          height="4"
          viewBox="0 0 16 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.55556 2.00016C3.55556 2.92064 2.75962 3.66683 1.77778 3.66683C0.795938 3.66683 0 2.92064 0 2.00016C0 1.07969 0.795938 0.333496 1.77778 0.333496C2.75962 0.333496 3.55556 1.07969 3.55556 2.00016Z"
            fill="#64648C" />
          <path
            d="M8 3.66683C8.98184 3.66683 9.77778 2.92064 9.77778 2.00016C9.77778 1.07969 8.98184 0.333496 8 0.333496C7.01816 0.333496 6.22222 1.07969 6.22222 2.00016C6.22222 2.92064 7.01816 3.66683 8 3.66683Z"
            fill="#64648C" />
          <path
            d="M14.2222 3.66683C15.2041 3.66683 16 2.92064 16 2.00016C16 1.07969 15.2041 0.333496 14.2222 0.333496C13.2404 0.333496 12.4444 1.07969 12.4444 2.00016C12.4444 2.92064 13.2404 3.66683 14.2222 3.66683Z"
            fill="#64648C" />
        </svg>
      </div>
    </div>
  </a>
</div>
    <!-- user profile ends here -->
  </div>
</div>
<!-- Static sidebar for desktop ends -->
</div>

<base-modal v-if="enitityModal" @close-modal="closeModal">
<div class="bg-white p-5 w-96 rounded-md shadow-sm">
                  <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                    <!-- Heroicon name: outline/check -->
                    <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div class="mt-3 text-center sm:mt-5">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">Entity Switcher</h3>
                    <div class="mt-2">
                      <p class="text-sm text-gray-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet labore.</p>
                    </div>
                  </div>
                  <div class="mt-5 sm:mt-6">
    <base-button class=" btn-primary w-full" @click="closeModal" >Go back to Navigation</base-button>
                </div>
                </div>
               
             
</base-modal>

</template>

<script>
import ProdcutSwitcher from './ProdcutSwitcher.vue';
import CbMenu from './CbMenu.vue';
import BrightBackMenu from './BrightBackMenu.vue'
import RevRecMenu from './RevRecMenu.vue'
import UnifiedHeader from './UnifiedHeader.vue'
import NavSearch from './NavSearch.vue';
import PaymentsMenu from './PaymentsMenu.vue';


export default {
    name: 'UnifiedNav',
    components: {
    ProdcutSwitcher,
    CbMenu,
    BrightBackMenu,
    RevRecMenu,
    UnifiedHeader,
    NavSearch,
    PaymentsMenu
},
    data(){
        return {
           cbMenu: true,
           bbMenu: false,
           rrMenu: false,
           menuDropdown: false,
           mobileMenu: true,
           dropMenuTitle: 'Billing',
           img: 'billing.svg',
           enitityModal: false,
           appSwitcher: false,
           productLists: []
        };
    },
    watch: {
      dropMenuTitle: function(newMenuTitle, oldMenuTitle) {

        switch(newMenuTitle) {
          case 'payments':
            this.$router.push('/payments')
          break;
          case 'billing':
          this.$router.push('/dashboards')
        }

        if(newMenuTitle === 'payments') {
          this.$router.push('/cb-payments')
        }
      }
    },
      methods: {

        openDropMenu(){
            
            this.menuDropdown = true;
            console.log(this.menuDropdown)
        },

        chnageToBrightback() {
            console.log("adsasd")
            this.cbMenu = false;
            this.bbMenu = true;
            this.rrMenu = false;
           
        
        },

        changeToRevlock() {
            this.bbMenu=false;
            this.cbMenu = false;
            this.rrMenu = true;
           
        },

        changeToCB(){
            this.cbMenu = true;
            this.bbMenu = false;
            this.rrMenu = false;
          
        },

        closeSelectionMenu(){
            this.menuDropdown = false;
        },

        selectMenu(title){
            this.dropMenuTitle = title;
            console.log(title)
            if(this.dropMenuTitle == 'billing') {
               this.cbMenu=true;
                
            }else if(this.dropMenuTitle == 'payments'){
               this.cbMenu=false
            }
            
            else if(this.dropMenuTitle == 'Retention') {
                this.changeToRevlock()
                this.img = 'billing.svg'
            } else if(this.dropMenuTitle == 'RevRec') {
                this.chnageToBrightback() 
                this.img = 'revrec.svg'
            }
            else if(this.dropMenuTitle == 'Marketplace') {
                this.chnageToBrightback() 
                this.img = 'billing.svg'
            }
            else if(this.dropMenuTitle == 'Receivables') {
                this.chnageToBrightback() 
                this.img = 'revrec.svg'
            }

            this.menuDropdown = false;
        },

        onClickEnitiySwitcher(){
            this.enitityModal = true
        },

        closeModal(){
          this.enitityModal = false
        },

        closeSwitcher(){
         // console.log("onclose ", this.appSwitcher)
          this.appSwitcher = false
        },

        openSwitcher(){
         
          this.appSwitcher = !this.appSwitcher;

          
        },
    },
    created(){
      // this.productLists = this.$store.getters['productsMenu/productsDetail'];
      // console.log(this.$route.name)
    }
}
</script>


<style scoped>
 .menu-a {
      @apply hover:bg-purple-50 text-gray-700 group-hover:text-purple-700  flex items-center px-2 py-2 text-sm font-medium leading-5 rounded-md;
    }
  
    .menu-icon {
      @apply text-gray-500 group-hover:text-purple-700 mr-3 flex-shrink-0 h-6 w-6;
    }
</style>